<template>
	<v-dialog v-model="showDialog" persistent max-width="300">
		<v-card>
			<v-card-title class="headline">{{ errorMessage.title ? errorMessage.title : 'Atenção' }}</v-card-title>
			<v-card-text>{{ errorMessage.message ? errorMessage.message : 'Ocorreu um erro.' }}</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="secondary" text @click="showDialog = false">{{ errorMessage.okText ? errorMessage.okText : 'Fechar' }}</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>


<script>
	export default {
		props: {
			showDialog: {
				type: Boolean,
				required: true
			},
			errorMessage: {
				title: {
					type: String,
				},
				message: {
					type: String,
				},
				okText: {
					type: String,
				}
			}
		},
		// data () {
		// 	return {
		// 		var_showDialog: this.showDialog
		// 	}
		// },
		// created () {
		// 	this.var_showDialog = this.showDialog;
		// },
		// computed : {
		// 	computedShowDialog: {
		// 		get: function () {
		// 			return this.var_showDialog
		// 		},
		// 		set: function (newValue) {
		// 			this.var_showDialog = newValue
		// 		}
		// 	}
		// },
		// methods: {
		// 	toggleShowDialog() {
		// 		// this.var_showDialog = !this.var_showDialog;
		// 		this.computedShowDialog = !this.computedShowDialog;
		// 	}
		// },
		// whatch: {
		// 	toggleShowDialog() {
		// 		console.log('emit watch');
		// 		this.$emit('toggle-show-dialog', this.showDialog);
		// 		computedShowDialog = !computedShowDialog;
		// 	}
		// }
	}
</script>